<template>
  <div>
    <b-form-file accept=".jpg,.jpeg,.png,.webp" @change="handleFileChange" />
    <div v-if="previewUrl" class="mt-3">
      <img :src="previewUrl" alt="Preview" class="w-100 rounded" style="max-height: 220px; object-fit: cover;">
    </div>
  </div>
</template>

<script>
import { uploadImage } from "../api/admin";
import { isUnauthorizedError } from "../utils/apiErrors";
import { resolveAssetUrl } from "../utils/asset";

export default {
  name: "ImageUploader",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    previewUrl: function previewUrl() {
      return this.value ? resolveAssetUrl(this.value) : "";
    }
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        return;
      }

      try {
        const response = await uploadImage(file);
        this.$emit("input", response.data.url);
        this.$bvToast.toast("Tải ảnh thành công.", {
          variant: "success",
          solid: true
        });
      } catch (error) {
        if (isUnauthorizedError(error)) return;

        this.$bvToast.toast(
          (error.response && error.response.data && error.response.data.message) ||
            "Không thể tải ảnh.",
          {
            variant: "danger",
            solid: true
          }
        );
      }
    }
  }
};
</script>

